<template>
  <div class="Inspection8">
    <h1 id="heading">Bewertung der Betriebserfahrungen</h1>
    <v-divider></v-divider>
    <div>
      <v-data-table
        :headers="headers"
        :items-per-page="5"
        :items="items"
        item-key="name"
        class="DataTable"
        hide-default-footer
      >
        <template slot="item" slot-scope="props">
          <tr @click="props.expanded = !props.expanded">
            <td class="text-xs-left" style="font-size: 120%">{{ props.item.name }}</td>
            <td class="text-xs-left" style="font-size: 120%">{{ props.item.assess }}</td>
            <td>
              <input
                type="radio"
                v-model="assessment"
                :key="props.item.assess"
                :value="props.item.assess"
              >
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="description">
        <v-dialog v-model="dialog" max-width="500px" :retain-focus="false">
          <template v-slot:activator="{ on }">
            <v-btn color="green" slot="activator" x-small fab v-on="on">
              <v-icon color="white" small>fas fa-info</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-toolbar color="green" height="50px">
              <v-toolbar-title style="color: white; font-size: 150%">Betriebserfahrungen</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn @click="close" small icon>
                <v-icon color="white">fas fa-times</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text style="font-size: 100%;">
              <p><br>
                Es ist die Einschätzung des Anlagenbetreibers erforderlich!<br><br>
Liegen keine Erfahrungen vor, da es sich z.B. um eine Neuanlage handelt, so
sollte von zumindest „Mäßige bekannte negative Einflüsse...“ ausgegangen
werden.
              </p>
              <br>
              <p style="text-decoration: underline;"></p>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
      <v-divider></v-divider>
      <v-btn color="blue" @click="nextPage" small fab>
        <v-icon color="white">fas fa-arrow-right</v-icon>
      </v-btn>
      <!-- <h1>{{assessment}}</h1> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Inspection8",
  props: ["assessmen"],
  data() {
    return {
      assessment: 0,
      assessHeader: "",
      dialog: false,
      items: [
        {
          name:
            "Keine bekannten negativen Einflüsse auf die Lebensdauer des zuvor auf der selben Anlage genutzten Seils",
          assess: 0
        },
        {
          name:
            "Mäßige bekannte negative Einflüsse auf die Lebensdauer des zuvor auf der selben Anlage genutzten Seils",
          assess: 1
        },
        {
          name:
            "Außerordentliche bekannte negative Einflüsse auf die Lebensdauer des zuvor auf der selben Anlage genutzten Seils",
          assess: 2
        }
      ],
      headers: [
        {
          text: "Alle Arten von Anlagen",
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "Relative Bewertung", sortable: false, value: "assess" }
      ]
    };
  },
  methods: {
    close() {
      this.dialog = false;
    },
    nextPage() {
      switch (this.assessment) {
        case 0:
          this.assessName =
            "Keine bekannten negativen Einflüsse auf die Lebensdauer des zuvor auf der selben Anlage genutzten Seils";
          break;
        case 1:
          this.assessName =
            "Mäßige bekannten negativen Einflüsse auf die Lebensdauer des zuvor auf der selben Anlage genutzten Seils";
          break;
        case 2:
          this.assessName =
            "Außerordentlich bekannten negativen Einflüsse auf die Lebensdauer des zuvor auf der selben Anlage genutzten Seils";
          break;
      }
      this.assessmen = this.assessmen + this.assessment;
      this.assessHeader = "Betriebserfahrungen";

      this.$emit("assessChanged", this.assessmen);
      this.$emit("assessmentName", this.assessName);
      this.$emit("assessmentHeader", this.assessHeader);
      this.$emit("assessmentActual", this.assessment);
      this.$emit("InspBefore", false);
      this.$emit("InspActual", true);
    }
  }
};
</script>

<style>
.Inspection8 {
  background-color: white;
  width: 90%;
  margin: 1% auto 0% auto;
  border: 1px solid black;
  border-radius: 5px;
  text-align: center;
}

.DataTable {
  width: 90%;
  margin-left: 5%;
}

#heading {
  font-size: 200%;
}
</style>
